<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 24/9/2020
  -->

<template>
	<qw-button v-bind="this.$attrs" :disabled="isStateProcessing">
		<slot v-if="isStateDefault">{{title}}</slot>
		<slot name="loading" v-if="isStateProcessing">
			<i class="fontello icon-spin5 mr-1"/>{{titleProcessing}}
		</slot>
		<slot name="success" v-if="isStateSuccess">
			<i class="fontello icon-ok-circle mr-1" :class="classSuccess"/>{{titleSuccess}}
		</slot>
		<slot name="failed" v-if="isStateFailed">
			<i class="fontello icon-cancel mr-1" :class="classFailed"/>{{titleFailed}}
		</slot>
	</qw-button>

</template>

<script>
import {OperationState} from "@/core/components/Controls/Buttons/OperationState";
import {delay} from "@/utils/helpers";

import BaseComponent from "@/core/components/BaseComponent.vue";

export default {
	extends: BaseComponent,
    name: "RemoteButton",

	props:{
		classSuccess: {Array, default: () => ["text-success"]},
		classFailed: {Array, default: () => ["text-danger"]},
		title:{String, default: "Save"},
		titleProcessing:{String, default: "Saving..."},
		titleSuccess:{String, default: "Saved"},
		titleFailed:{String, default: "Failed"},
	},

	data(){
    	return {
    		state: OperationState.DEFAULT
		}
	},

	methods:{
    	async onClick(event){
    		console.log("submitFormInternal: onClick onClick: event = ",event)
			this.state = OperationState.PROCESSING
			try{
				let isSuccess = await this.emitPromise("click")
				if(isSuccess || isSuccess === undefined){
					await this.success()
				} else {
					await this.failed()
				}
			} catch (error){
    			this.handleError(error)
				await this.failed()
			}
		},

		async success(){
			this.state = OperationState.SUCCESS
			await delay(2000)
			await this.completed()
		},

		async failed(){
			this.state = OperationState.FAILED
			await delay(2000)
			await this.completed()
		},

		async completed(){
			this.state = OperationState.DEFAULT
		}
	},

	computed:{

    	// listeners(){
		// 	let {onClick, ...attrs} = this.$attrs
		// 	return {
		// 		...attrs,
		// 		onClick: event => this.onClick(event)
		// 	}
		// },

		isStateDefault(){
			return this.state === OperationState.DEFAULT
		},

		isStateProcessing(){
			return this.state === OperationState.PROCESSING
		},

		isStateSuccess(){
			return this.state === OperationState.SUCCESS
		},

		isStateFailed(){
			return this.state === OperationState.FAILED
		},
	}
}
</script>

<style lang="scss">

</style>
